import { mapLicenseNameToSubscription } from '@innovyze/stylovyze/lib/utils/forgeLicense';
export const mapEntitlements = (licenses) => {
    const entitlements = [];
    for (const entry of licenses) {
        if (entry.auth) {
            entitlements.push(mapLicenseNameToSubscription(entry.fid));
        }
    }
    return entitlements;
};
